import {InlineCodeProps} from '../components/inline-code';
export const getInlineCode =
  <T>(data: Omit<InlineCodeProps, 'type'>) =>
  (): InlineCodeProps => ({
    ...data,
    type: 'inline-code',
  });
